module.exports = __webpack_public_path__ + "static/OIC logo.10f9f991.svg";